<div
  class="position-absolute history z-1 translate-middle-x start-50 bg-dark border border-darkgray rounded-2"
>
  <div class="position-relative d-flex align-items-center gap-3 p-3">
    <app-datetime-picker
      [date]="currentDate?.toISOString()"
      (datetimeChanged)="handleOnTimestampChanged($event)"
      [disabled]="isLoading()"
    >
    </app-datetime-picker>
    <div *ngIf="isLoading()" class="position-relative d-flex align-items-center">
      <div class="position-absolute translate-middle start-50 top-50">
        <div class="spinner-border text-white spinner-border-sm" role="status"></div>
      </div>
    </div>
  </div>
</div>
